var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section reserves-from-app"},[_c('h2',{staticClass:"section__title"},[_vm._v("Резервы из приложения")]),_c('data-table',{ref:"table",attrs:{"options":_vm.tableOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }